// Default spell schools (used as fallback when Firestore schools not loaded)
export const DEFAULT_SPELL_SCHOOLS = [
  { slug: 'abjuration', name: 'Abjuration', icon: '🛡️', color: '#4A90D9' },
  { slug: 'conjuration', name: 'Conjuration', icon: '🌀', color: '#9B59B6' },
  { slug: 'divination', name: 'Divination', icon: '👁️', color: '#3498DB' },
  { slug: 'enchantment', name: 'Enchantment', icon: '💫', color: '#E91E63' },
  { slug: 'evocation', name: 'Evocation', icon: '🔥', color: '#E74C3C' },
  { slug: 'illusion', name: 'Illusion', icon: '🎭', color: '#9C27B0' },
  { slug: 'necromancy', name: 'Necromancy', icon: '💀', color: '#2C3E50' },
  { slug: 'transmutation', name: 'Transmutation', icon: '⚗️', color: '#27AE60' },
]

// Legacy export for backwards compatibility
export const SPELL_SCHOOLS = DEFAULT_SPELL_SCHOOLS.map(s => ({
  id: s.slug,
  label: s.name,
}))

export const SPELL_LEVELS = [
  { value: 0, label: 'Cantrip' },
  { value: 1, label: '1st Level' },
  { value: 2, label: '2nd Level' },
  { value: 3, label: '3rd Level' },
  { value: 4, label: '4th Level' },
  { value: 5, label: '5th Level' },
  { value: 6, label: '6th Level' },
  { value: 7, label: '7th Level' },
  { value: 8, label: '8th Level' },
  { value: 9, label: '9th Level' },
]

export function formatSpellLevel(level) {
  if (level === 0) return 'Cantrip'
  const suffixes = ['th', 'st', 'nd', 'rd']
  const suffix = level <= 3 ? suffixes[level] : 'th'
  return `${level}${suffix}-level`
}

export function getSchoolLabel(schoolId) {
  const school = SPELL_SCHOOLS.find(s => s.id === schoolId)
  return school?.label || schoolId
}

export function formatComponents(components) {
  if (!components) return ''
  const parts = []
  if (components.verbal) parts.push('V')
  if (components.somatic) parts.push('S')
  if (components.material) parts.push('M')

  let result = parts.join(', ')
  if (components.material && components.materialDescription) {
    result += ` (${components.materialDescription})`
  }
  return result
}
